export default "__VITE_ASSET__jRwdEpXK__"